import { default as SubnavigationItem } from './SubnavigationItem';

export default SubnavigationItem;
